import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ZipCountyStateStructure } from '../../interfaces/zipCountyStateStructure.interface';
import { ZIP_COUNTY_STATE_NAME } from 'src/app/angular-elements/demographics/zip-county-modal/reducers/zipCounty.reducer';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { GLOBAL_DATA_PARAM_KEYS } from 'src/app/shared/enums/query-params.enum';
import { PtlWindowLocationService } from '@ptl/global-components';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';

@Component({
    selector: 'app-internal-data-redirect',
    templateUrl: './internal-data-redirect.component.html',
    styleUrls: ['./internal-data-redirect.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InternalDataRedirectComponent implements OnInit{

  @Input() url: string;
  @Input() shouldAddZipCountyString: string;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private authoringMode: AuthoringModeService,
    private windowLocationService: PtlWindowLocationService
  ) {}

  ngOnInit() {
    // Don't redirect if in author mode
    if (this.authoringMode.getAuthoringMode()) {
      return;
    }

    let shouldAddZipCounty: boolean = this.shouldAddZipCountyString == "true";
    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState(ZIP_COUNTY_STATE_NAME);

    // setup for adding query params
    this.url += '?';

    // Add zip code and county params if they are required and exist
    if (shouldAddZipCounty && zipCountyState?.zipCode && zipCountyState?.county?.county) {
      this.url += `${GLOBAL_DATA_PARAM_KEYS.ZIP_CODE}=${zipCountyState.zipCode}&`;
      this.url += `${GLOBAL_DATA_PARAM_KEYS.COUNTY}=${zipCountyState.county.county}&`;
    }

    this.windowLocationService.goToUrl(this.url);
  }
}
